module.exports = __webpack_public_path__ + "static/img/A101.37c4a7c3.jpg";